// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","526":"pages-DebugPage","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"b74f996e062d529ca23c","85":"79eb8c5bebb82129c87f","526":"487d9785ae6fe202d1b2","777":"9662a3c082651731a49e"}[chunkId] + ".js";
};